import requests from "@/utils/request";
import store from "@/store";

let request = requests.request;
let lang = store.state.isLang != "zh-CN" ? "en_en" : "zh_cn";

// 获取云服务器列表
export function getServerList(params) {
  return request.get("/cloudServers", { lang, params });
}

// 获取云服务器统计
export function getServerStatistics() {
  return request.get("/cloudServerStatistics", { lang });
}

// 云服务/api续费
export function cloudServeRenew(data) {
  return request.post("/order/renew", { lang, ...data });
}

// 多实例续费
export function moreRenews(data) {
  return request.post("/renewal/batch", { lang, ...data });
}
